/**
 * 日期格式化工具函数
 */

/**
 * 将日期字符串格式化为本地日期格式
 * @param {string} dateString - ISO格式的日期字符串
 * @returns {string} 格式化后的日期字符串
 */
export const formatDate = (dateString) => {
    if (!dateString) return '未知日期';

    try {
        const date = new Date(dateString);
        return date.toLocaleDateString('zh-TW', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    } catch (error) {
        console.error('日期格式化错误:', error);
        return dateString;
    }
};

/**
 * 将保修单状态代码转换为显示名称
 * @param {string} status - 状态代码
 * @returns {string} 状态显示名称
 */
export const getStatusName = (status) => {
    const statusMap = {
        'Pending': '待處理',
        'Approved': '已批准',
        'Rejected': '已拒絕'
    };

    return statusMap[status] || status;
};

/**
 * 获取保修单状态对应的CSS类名
 * @param {string} status - 状态代码
 * @returns {string} CSS类名
 */
export const getStatusClass = (status) => {
    const classMap = {
        'Pending': 'status-pending',
        'Approved': 'status-approved',
        'Rejected': 'status-rejected'
    };

    return classMap[status] || 'status-default';
};

/**
 * 格式化产品名称，截断过长的名称
 * @param {string} name - 产品名称
 * @param {number} maxLength - 最大长度
 * @returns {string} 格式化后的产品名称
 */
export const formatProductName = (name, maxLength = 30) => {
    if (!name) return '';
    return name.length > maxLength ? `${name.substring(0, maxLength)}...` : name;
};

/**
 * 从完整ID中提取数字ID
 * @param {string} fullId - 完整ID
 * @returns {string} 提取的数字ID
 */
export const extractNumericId = (fullId) => {
    if (!fullId) return '';

    // 尝试从路径中提取ID
    if (fullId.includes('/')) {
        return fullId.split('/').pop();
    }

    return fullId;
}; 